import {
  checkForMaxStake,
  checkForNumberOfBets,
  checkForStopOnLoss,
  checkForStopOnWin,
} from './checkers'

export const checkAutoConfigs = (
  betCount: number,
  autoRollNumber: string,
  stopOnLoss: string,
  stopOnProfit: string,
  ggr: any,
  stake: string,
  autoMaxStake: string,
  setStep: (s: string) => void,
) => {
  if (checkForNumberOfBets(betCount, Number(autoRollNumber))) {
    return setStep('STOP_ON_NUMBER_OF_BETS')
  }
  if (checkForStopOnLoss(stopOnLoss, ggr)) {
    return setStep('STOP_ON_lOSS')
  }
  if (checkForStopOnWin(stopOnProfit, ggr)) {
    return setStep('STOP_ON_PROFIT')
  }
  if (checkForMaxStake(stake, autoMaxStake)) {
    return setStep('STOP_ON_MAX_STAKE')
  }

  return true
}
